<template>
    <router-view></router-view>
</template>

<script>
import global from '../util/globalVar'
export default {
    props: ['region'],
    watch: {
        $route: {
            handler() {
                this.initRegionLang()
            },
            immediate: true
        }
    },
    methods: {
        initRegionLang() {
            global.region = this.region
            global.lang = this.$route.params.lang
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/main.vue